import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

// --- SVG Icons for Bottom Nav ---
const HomeIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" /></svg>
);
const AboutIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 12h3v8h14v-8h3L12 2zm-2 16h-2v-4h2v4zm4 0h-2v-4h2v4zm4-1.74l-8-6.55-8 6.55V12h16v6.26z" /></svg>
);
const ActivitiesIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></svg>
);
const CampsIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 12h3v8h14v-8h3L12 2zm-2 16h-2v-4h2v4zm4 0h-2v-4h2v4zm4-1.74l-8-6.55-8 6.55V12h16v6.26z" /></svg>
);
const ProfileIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>
);

// --- SVG Icons for the new Activities Popup ---
const WorkshopIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/></svg>
);
const SeminarIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/></svg>
);
const WebinarIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M21 3H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z"/></svg>
);
const AllActivitiesIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/></svg>
);

// --- Chevron Icon for the new Login Dropdown ---
const ChevronDownIcon = ({ isOpen }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={`chevron-icon ${isOpen ? 'open' : ''}`} viewBox="0 0 20 20" fill="currentColor">
      <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
    </svg>
);

// --- NEW Login Dropdown Component ---
const LoginDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen(!isOpen);
    const closeDropdown = () => setIsOpen(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <li className="nav-item login-dropdown-wrapper" ref={dropdownRef}>
            <button onClick={toggleDropdown} className="nav__btn nav__login-btn login-dropdown-btn">
                Login
                <ChevronDownIcon isOpen={isOpen} />
            </button>
            {isOpen && (
                <ul className="login-dropdown-menu">
                    <li>
                        <a href="https://mentor.ethiccraft.org" className="login-dropdown-item" onClick={closeDropdown} target="_blank" rel="noopener noreferrer">
                            Mentor Login
                        </a>
                    </li>
                    <li>
                        <a href="https://admin.ethiccraft.org" className="login-dropdown-item" onClick={closeDropdown} target="_blank" rel="noopener noreferrer">
                            Admin Login
                        </a>
                    </li>
                    <li>
                        <NavLink to="/login" className="login-dropdown-item" onClick={closeDropdown}>
                            Student Login
                        </NavLink>
                    </li>
                </ul>
            )}
        </li>
    );
};


const Navbar = ({ onTogglePanel }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activitiesPopupOpen, setActivitiesPopupOpen] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [profilePic, setProfilePic] = useState("");
  const location = useLocation();
  const onDashboard = location.pathname.startsWith("/dashboard");

  const generateDefaultAvatar = (name = "User") => (
    `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&size=100&background=random&color=fff`
  );

  const actualCookieName = "email";

  useEffect(() => {
    const userCookie = Cookies.get(actualCookieName);
    if (userCookie) {
      setLoggedIn(true);
      fetchUserProfile(userCookie);
    } else {
      setLoggedIn(false);
      setUserData(null);
      setProfilePic(generateDefaultAvatar());
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (menuOpen || activitiesPopupOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen, activitiesPopupOpen]);

  const fetchUserProfile = async (token) => {
    if (!token) {
      setLoggedIn(false);
      return;
    }
    try {
      const response = await fetch('https://ethiccraft.org/backend/profile/read_emails.php', {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Failed to fetch user data");
      const data = await response.json();
      if (data && data.email) {
        setUserData(data);
        const nameParam = data.full_name ? data.full_name.replace(" ", "+") : "User";
        setProfilePic(data.profile_image ? `https://ethiccraft.org/${data.profile_image}` : `https://ui-avatars.com/api/?name=${nameParam}&size=100&background=random&color=fff`);
      } else {
        setUserData(null);
        setProfilePic(generateDefaultAvatar());
      }
    } catch (error) {
      console.error("Error in fetchUserProfile:", error);
      setProfilePic(generateDefaultAvatar());
      setUserData(null);
    }
  };

  const handleLogout = () => {
    Cookies.remove(actualCookieName, { path: '/' });
    setLoggedIn(false);
    setUserData(null);
    setProfilePic(generateDefaultAvatar());
    setMenuOpen(false);
    window.location.href = "/Login";
  };

  const handleProfilePicError = () => {
    setProfilePic(generateDefaultAvatar());
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);
  const toggleActivitiesPopup = () => setActivitiesPopupOpen(!activitiesPopupOpen);
  const closeActivitiesPopup = () => setActivitiesPopupOpen(false);

  // -- Desktop Nav Links ---
  const desktopNavLinks = () => (
    <>
      <li className="nav-item"><NavLink to="/" >Home</NavLink></li>
      <li className="nav-item"><NavLink to="/about">About</NavLink></li>
      <li className="nav-item"><NavLink to="/activities">Activities</NavLink></li>
      <li className="nav-item"><NavLink to="/chapters">Chapters</NavLink></li>
      <li className="nav-item"><NavLink to="/camps">Camps</NavLink></li>
      <li className="nav-item"><NavLink to="/valumni">Valumni</NavLink></li>
    </>
  );

  // --- Profile/Auth Section for the Full-Screen Mobile Menu ---
  const mobileMenuHeader = () => {
    if (loggedIn && userData) {
      return (
        <div className="nav__mobile-profile">
          <img src={profilePic} alt="Profile" className="nav__profile-pic" onError={handleProfilePicError} />
          <h3 className="nav__profile-name">Hi, {userData.full_name || "User"}</h3>
          <p className="nav__profile-email">{userData.email}</p>
          <div className="nav__mobile-actions">
              <NavLink to="/dashboard" className="nav__btn" onClick={closeMenu}>Dashboard</NavLink>
              <NavLink to="/dashboard/profileEdit" className="nav__btn" onClick={closeMenu}>Edit Profile</NavLink>
              <NavLink to="/dashboard/certificates" className="nav__btn" onClick={closeMenu}>Certificates</NavLink>
              <NavLink to="/dashboard/events-booked" className="nav__btn" onClick={closeMenu}>Events Booked</NavLink>
              <button onClick={handleLogout} className="nav__btn nav__btn--logout">Log Out</button>
          </div>
        </div>
      );
    } else if (!loggedIn) {
      return (
        <div className="nav__mobile-profile">
          <LoginDropdown />
        </div>
      );
    } else {
      return null; // Wait for userData to load before showing anything
    }
  };

  const activitiesPopupMenu = () => (
    <div className={`activities-popup ${activitiesPopupOpen ? "open" : ""}`}>
        <div className="activities-popup__overlay" onClick={closeActivitiesPopup}></div>
        <div className="activities-popup__menu">
            <NavLink to="/chapters" className="activities-popup__item" onClick={closeActivitiesPopup}>
                <WorkshopIcon className="activities-popup__icon" />
                <span>Ethiccraft_Chapters</span>
            </NavLink>
            <NavLink to="/valumni" className="activities-popup__item" onClick={closeActivitiesPopup}>
                <SeminarIcon className="activities-popup__icon" />
                <span>Valumni</span>
            </NavLink>
            <NavLink to="/campus-ambassador" className="activities-popup__item" onClick={closeActivitiesPopup}>
                <WebinarIcon className="activities-popup__icon" />
                <span>Campus Ambassadors</span>
            </NavLink>
            <div className="activities-popup__divider"></div>
            <NavLink to="/activities" className="activities-popup__item" onClick={closeActivitiesPopup}>
                <AllActivitiesIcon className="activities-popup__icon" />
                <span>All Activities</span>
            </NavLink>
        </div>
    </div>
  );

  // --- Render the Navbar ---
  return (
    <>
      {/* --- DESKTOP TOP NAVBAR --- */}
      <nav className="navbar-desktop">
        <div className="navbar__container">
          <div className="navbar__left">
            <NavLink to="/" className="navbar__logo-link">
              <img src="assets/ethiccraft_full_logo.png" alt="Ethiccraft Logo" className="navbar__logo-img" />
            </NavLink>
          </div>

          <ul className="nav__links-desktop">
            {desktopNavLinks()}
            {loggedIn && userData ? (
                <li className="nav-item nav-item-profile">
                    <div className="nav__profile-toggle">
                    <img src={profilePic} alt="Profile" className="nav__profile-pic" onError={handleProfilePicError} />
                    </div>
                    <div className="nav__profile-dropdown">
                    <div className="nav__profile-header">
                        <h2>Hi, {userData.full_name || "User"}</h2>
                    </div>
                    <NavLink to="/dashboard" className="nav__dropdown-item" onClick={closeMenu}>Dashboard</NavLink>
                    <button onClick={handleLogout} className="nav__dropdown-item nav__logout-btn">Log Out</button>
                    </div>
                </li>
            ) : (
                // *** THIS IS THE REPLACEMENT ***
                <LoginDropdown />
            )}
          </ul>
        </div>
      </nav>

      {/* --- MOBILE/TABLET FLOATING BOTTOM NAVBAR --- */}
      <nav className="navbar-mobile">
        <NavLink to="/" className="navbar-mobile__link">
          <HomeIcon className="navbar-mobile__icon" />
          <span>Home</span>
        </NavLink>
        <NavLink to="/about" className="navbar-mobile__link">
          <AboutIcon className="navbar-mobile__icon" />
          <span>About</span>
        </NavLink>
        <button onClick={toggleActivitiesPopup} className="navbar-mobile__link navbar-mobile__button">
          <ActivitiesIcon className="navbar-mobile__icon" />
          <span>More</span>
        </button>
        <NavLink to="/camps" className="navbar-mobile__link">
          <CampsIcon className="navbar-mobile__icon" />
          <span>Camps</span>
        </NavLink>
        <button onClick={toggleMenu} className="navbar-mobile__link navbar-mobile__button">
           <ProfileIcon className="navbar-mobile__icon" />
           <span>Profile</span>
        </button>
      </nav>

      {/* --- RENDER POPUP AND FULLSCREEN MENUS --- */}
      {activitiesPopupMenu()}

      {/* --- FULL SCREEN MENU (Opened by Profile button on mobile) --- */}
      <div className={`nav__menu-fullscreen ${menuOpen ? "open" : ""}`}>
          <div className="nav__menu-fullscreen-header">
              <NavLink to="/" className="navbar__logo-link" onClick={closeMenu}>
                  <img src="assets/ethiccraft_full_logo.png" alt="Ethiccraft Logo" className="navbar__logo-img" />
              </NavLink>
              <button
                  className={`nav__menu-close-btn ${menuOpen ? "open" : ""}`}
                  onClick={toggleMenu}
                  aria-label="Close navigation menu"
              >
                  <span></span>
                  <span></span>
              </button>
          </div>
          <div className="nav__mobile-scrollable">
              {mobileMenuHeader()} 
          </div>
        </div>
    </>
  );
};

export default Navbar;